import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

const URL = getOrigin("www") + "/sapi/v4/balance/public/finance/";
const URL1 = getOrigin("www") + "/sapi/v4/balance/finance/";
const URL2 = getOrigin("www") + "/sapi/v4/order/finance/";

//获取理财产品
export function get_product(config) {
  return XtAxios4.get(URL + `product`, config);
}
//获取单个理财产品
export function get_product_by_id(config) {
  return XtAxios4.get(URL + `product/id`, config);
}
//获取单个产品已申购数量
export function get_productSubscribed(config) {
  return XtAxios4.get(URL + `product/subscribed`, config);
}
//查询是否不是新用户
export function get_not_novice(config) {
  return XtAxios4.get(URL + `product/not-novice`, config);
}
//获取用户资产
export function get_balances(config) {
  return XtAxios4.get(URL1 + `balance`, config);
}
//单个产品的持仓（申购框内显示）
export function get_productPosition(config) {
  return XtAxios4.get(URL1 + `product-position`, config);
}
//申购/赎回
/*
{
  "bizId": "1231231",
  "productId": 0,
  "type": "SUBSCRIBE",
  "amount": 0,
  "currency": "string",
  "stakingAmount": 0,
  "stakingCurrency": "string"
}
*/
export function post_order(data, config) {
  return XtAxios4.post(URL2 + `order`, data, config);
}
//自动申购
export function post_autoSubscribe(data, config) {
  return XtAxios4.post(URL2 + `auto-subscribe`, data, config);
}